import React from 'react';

import { Box, Grid, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import { yearsTicks } from '../config';
import { periods } from '../helpers/commonHelpers';

const useStyles = makeStyles(theme => ({
  defaultStyle: {
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(1),
  },
  tickPadding: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    textAlign: 'center',
  },
  tick: {
    backgroundColor: theme.palette.primary.light,
    width: 2,
    height: 10,
  },
  futureColor: {
    color: ({ futureColor }) => futureColor,
  },
  arrowDown: {
    width: 0,
    height: 0,
    borderLeft: ({ triangleSide }) => `${triangleSide}px solid transparent`,
    borderRight: ({ triangleSide }) => `${triangleSide}px solid transparent`,
    borderTop: ({ triangleSide }) => `${triangleSide}px solid ${theme.palette.secondary.main}`,
    marginBottom: theme.spacing(1),
    marginLeft: ({ triangleSide }) => `-${triangleSide}px`, // to center the triangle
    textAlign: 'center',
    left: ({ trianglePosition }) => `${trianglePosition}%`,
    position: 'relative',
  },
}));

const { start, end, step, stepTick, switchColorYear } = yearsTicks;
const numTicks = (end - start) / step;
const yearsArray = [...Array(numTicks + 1).keys()].map(value => start + value * step);
const ticksArray = [...Array(yearsArray.length * stepTick).keys()];
const futureColor = periods.find(({ period }) => period === 'FUTUR')?.color;
const triangleSide = 15;
const trianglePosition = ((switchColorYear - start) * 100) / (end - start);

const YearsTicks = () => {
  const classes = useStyles({ futureColor, triangleSide, trianglePosition });

  return (
    <Box className={classes.defaultStyle}>
      <div className={classes.tickPadding}>
        <div className={classes.arrowDown} />
      </div>
      <Grid
        container
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        className={classes.tickPadding}
      >
        {ticksArray.map(index => (
          <Grid item key={`home-year-ticks-${index}`}>
            <div className={classes.tick} />
          </Grid>
        ))}
      </Grid>
      <Grid
        container
        direction="row"
        justifyContent="space-between"
        alignItems="center"
      >
        {yearsArray.map(year => (
          <Grid item key={`home-year-${year}`}>
            <Typography
              color="secondary"
              classes={({
                root: year >= switchColorYear ? classes.futureColor : '',
              })}
            >
              {year}
            </Typography>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default YearsTicks;
